import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getTarrotCardData = createAsyncThunk(
  "getTarrotCardData",
  async (payload) => {
    let requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };

    console.log("cardData======>", payload);


    let res = await fetch(
      `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}product-management/product-management-list`,
      requestOptions
    );

    res = await res.json();

    return res;
  }
);

const TarrotCardReducer = createSlice({
  name: "TarrotCardReducer",
  initialState: {
    cardData: [],
    loader: false,
    cartCount: 0
  },
  reducers: {
    setCardData: (state, action) => {
        console.log(state, "----------->");
        state.cardData = []
    },
    updateProductCount: (state, action) => {
      state.cartCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTarrotCardData.pending, (state, action) => {
      console.log(state, action, "==========>");

      state.loader = true;

  })
    builder.addCase(getTarrotCardData.fulfilled, (state, action) => {
        console.log(state, action, "==========>");

        state.cardData = action.payload.results.res
        state.loader = false;

    })
  }
});

export const { setCardData, updateProductCount } = TarrotCardReducer.actions;

export default TarrotCardReducer.reducer;
